import { render, staticRenderFns } from "./_lobby.vue?vue&type=template&id=c25550ba&lang=pug&"
import script from "./_lobby.vue?vue&type=script&lang=js&"
export * from "./_lobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports